// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__Gko61","ranges":"BmiRanges_ranges__2uL0q"};